import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from "vue";
import gsap from 'gsap'


export default /*#__PURE__*/_defineComponent({
  __name: 'GlitchAnimation',
  props: {
  text: {
    type: String,
    default: ''
  },
  is: {
    type: String,
    default: 'div'
  },
  delay: {
    type: Number,
    default: 1
  },
  duration: {
    type: Number,
    default: 1
  },
  ease: {
    type: String,
    default: 'quart.out'
  }
},
  emits: ['ready'],
  setup(__props, { emit }) {

const props = __props;






const progress = ref(0)
onMounted(() => {
  gsap.timeline({delay: props.delay})
    .fromTo(
      progress,
      { value: 0 },
      { 
        value: 1,
        duration: props.duration,
        ease: props.ease
      }
    )
  emit('ready')
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.is), { class: "glitch-element" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "glitch",
        style: _normalizeStyle(`clip-path: inset(0 0 ${(progress.value) * 100}% 0);`)
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 4),
      _createElementVNode("div", {
        class: "base",
        style: _normalizeStyle(`clip-path: inset(${(1 - progress.value) * 100}% 0 0 0);`)
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 4)
    ]),
    _: 3
  }))
}
}

})